<template>
    <div>
        <h3 v-b-tooltip.hover="`（${detailForm?.name}）`" class="text-truncate" style="position: absolute; top: -40px; left: 40px">
            （{{ detailForm?.name }}）
        </h3>
        <div class="card-header">
            <div class="d-flex">
                <div class="title--screen" style="white-space: nowrap">
                    {{ $t('managerForm.analytics.searchSerialCode') }}
                </div>
            </div>
        </div>
        <div class="card-body">
            <div class="row justify-content-center">
                <div class="col-8">
                    <!-- シリアルコード -->
                    <div class="form-group row">
                        <label class="col-sm-1" style="min-width: 280px">シリアルコード</label>
                        <div class="col">
                            <InputText :model.sync="searchForm.search.serial_code" :config.sync="configForm.search.serial_code" />
                        </div>
                    </div>

                    <!-- 利用ステータス -->
                    <div class="form-group row">
                        <label class="col-sm-1" style="min-width: 280px">利用ステータス</label>
                        <div class="col-sm-9">
                            <div class="d-flex flex-wrap">
                                <div v-for="item in LIST_USE_STATUS" :key="item.id + '-use-status'">
                                    <InputRadio
                                        class="mr-3 mb-2"
                                        :model.sync="searchForm.filters.is_used"
                                        :id="`use-status-${item.id}`"
                                        name="use_status"
                                        :value="item.id"
                                        :label="item.name"
                                    />
                                </div>
                                <div>
                                    <InputRadio
                                        class="mr-3 mb-2"
                                        :model.sync="searchForm.filters.is_used"
                                        id="use-status-all"
                                        name="use_status"
                                        :value="null"
                                        label="全て"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- シリアルコード利用制限回数 -->
                    <div class="form-group row">
                        <label class="col-sm-1" style="min-width: 280px">シリアルコード利用制限回数</label>
                        <div class="col" style="max-width: 200px">
                            <InputText :model.sync="searchForm.filters.use_limit" :config.sync="configForm.filters.use_limit" type="number" />
                        </div>
                    </div>

                    <!-- Buttons -->
                    <div class="text-center text-nowrap">
                        <button type="button" @click="handleClearSearch" class="btn btn-common btn-outline-primary">
                            <i class="ri-restart-line"></i>{{ $t('btn.clear') }}
                        </button>
                        <button type="button" @click="handleSearch" class="btn btn-common btn-primary ml-3">
                            <i class="ri-search-line"></i>{{ $t('btn.search') }}
                        </button>
                    </div>
                </div>
            </div>

            <!-- Kết quả tìm kiếm -->
            <div class="mt-4">
                <h3 class="mb-0 mt-3 title--screen">
                    シリアルコード一覧 <span>件数 ({{ configPage.total }})</span>
                </h3>
                <div class="d-flex justify-content-end mb-2" style="align-items: center; gap: 10px">
                    <span v-if="isProcessing" class="mr-2"> {{ $t('common.processDownload') }} ({{ downloadProgress }}%) </span>
                    <button type="button" class="btn btn-common btn-success" :disabled="isProcessing" @click="handleDownloadSerialCodes">
                        <i class="ri-file-download-line"></i>データダウンロード
                    </button>
                </div>
                <TableListComponent
                    :heightTable="`calc(100vh - 560px)`"
                    :config="configTable"
                    :dataList="listDataTable"
                    :isLoading="isLoading"
                    :configPage.sync="configPage"
                    :stickyAction="false"
                    @onChangePage="getList()"
                    class="mt-2"
                >
                    <template #row="{ row }">
                        <tr>
                            <!-- No. -->
                            <td class="text-center">{{ row.no }}</td>
                            <!-- Mã serial code -->
                            <td class="text-left el-table__cell">{{ row.serial_code }}</td>
                            <!-- Số lần sử dụng -->
                            <td class="text-center el-table__cell">{{ row.quantity_limit }}</td>
                            <!-- Số lần sử dụng còn lại -->
                            <td class="text-center el-table__cell">{{ row.remaining_quantity }}</td>
                            <!-- Trạng thái sử dụng -->
                            <td class="text-center el-table__cell">
                                <span :class="row.status == 1 ? 'badge badge-danger' : 'badge badge-success'">
                                    {{ row.status == 1 ? '利用済' : '未使用' }}
                                </span>
                            </td>
                            <!-- Ngày giờ sử dụng -->
                            <td class="text-left el-table__cell">
                                {{ row.last_used_at }}
                            </td>
                        </tr>
                    </template>
                </TableListComponent>
            </div>
        </div>
    </div>
</template>

<script>
import { formatDateCommon, handleDownFile } from '@/utils/format';
import { configs } from '../../constants';
import { managerFormMethods } from '@/state/helpers';
import { InputText, InputRadio } from '@/components/Input';
import { initSearchSerialCode, initConfigSearchSerialCode, LIST_USE_STATUS } from './constants';
import TableListComponent from '@/components/TableList/main.vue';
import runJobMinxin from '@/mixins/runJobMinxin';
import { showMessage } from '@/utils/messages';

export default {
    name: 'SearchSerialCode',
    props: {
        detailForm: {
            type: Object,
            default: () => ({})
        }
    },
    components: { TableListComponent, InputText, InputRadio },
    mixins: [runJobMinxin],
    async mounted() {
        await this.getList();
    },
    data() {
        return {
            configPage: { ...configs.configPage },
            configTable: {
                widthAction: 0,
                headers: [
                    { label: 'No.', width: 60 },
                    { label: 'シリアルコード', width: 200 },
                    { label: '利用回数', width: 120 },
                    { label: '残り利用回数', width: 140 },
                    { label: '利用ステータス', width: 140 },
                    { label: '利用日時', width: 200 }
                ]
            },
            listDataTable: [],
            isLoading: false,
            searchForm: initSearchSerialCode(),
            configForm: initConfigSearchSerialCode(),
            LIST_USE_STATUS,
            isProcessing: false,
            downloadProgress: 0
        };
    },
    methods: {
        ...managerFormMethods,
        formatDateCommon,

        getQueryString() {
            const params = [`page=${this.configPage.page}`, `limit=${this.configPage.limit}`, `sorts[last_used_at]=desc`];

            if (this.searchForm.search.serial_code) {
                params.push(`search[serial_code]=${encodeURIComponent(this.searchForm.search.serial_code)}`);
            }
            if (this.searchForm.filters.is_used !== null && this.searchForm.filters.is_used !== undefined) {
                params.push(`filters[status]=${this.searchForm.filters.is_used}`);
            }
            if (this.searchForm.filters.use_limit !== null && this.searchForm.filters.use_limit !== '') {
                params.push(`filters[quantity_limit]=${this.searchForm.filters.use_limit}`);
            }

            return '?' + params.join('&');
        },

        async getList() {
            const query = this.getQueryString();
            this.isLoading = true;
            try {
                const data = await this.getListSerialCodeAnalytics({
                    form_id: this.$route.query.id,
                    query
                });
                this.listDataTable = (data.data ?? []).map((item, index) => ({
                    ...item,
                    no: (this.configPage.page - 1) * this.configPage.limit + index + 1
                }));
                this.configPage.total = data._metadata?.total ?? 0;
                this.configPage.limit = data._metadata?.limit ? data._metadata.limit * 1 : 10;
                if (!this.listDataTable.length && this.configPage.page !== 1) {
                    this.configPage.page = 1;
                    this.getList();
                }
            } catch (error) {
                console.log('error', error);
            } finally {
                this.isLoading = false;
            }
        },

        handleSearch() {
            this.configPage.page = 1;
            this.getList();
        },

        handleClearSearch() {
            this.searchForm = initSearchSerialCode();
            this.configPage = { ...configs.configPage };
            this.listDataTable = [];
            this.getList();
        },

        async handleDownloadSerialCodes() {
            if (this.isProcessing) return;
            this.isProcessing = true;
            let payload = {
                id: this.$route.query?.id ? Number(this.$route.query?.id) : null,
                param: this.getQueryString()
            };
            const onProgress = (r, t, p) => {
                this.downloadProgress = p;
            };
            try {
                const dataExportRes = await this.downloadSerialCodes(payload);
                if (dataExportRes?.status && dataExportRes?.data?.file_id) {
                    let successCallback = async (res) => {
                        this.downloadProgress = 100;
                        await handleDownFile(res?.path, res?.file_name, onProgress).catch(() => {
                            showMessage(400, this.$bvToast, this.$t('system.error'));
                        });
                        showMessage(200, this.$bvToast, 'ダウンロード処理が完了しました。');
                        this.isProcessing = false;
                        this.downloadProgress = 0;
                    };
                    let errorCallback = (res) => {
                        showMessage(400, this.$bvToast, this.$t(res?.data?.error_message || 'system.error'));
                        this.isProcessing = false;
                        this.downloadProgress = 0;
                    };
                    await this.startPollingJobStatus(dataExportRes?.data?.file_id, successCallback, errorCallback, {
                        ...dataExportRes?.data
                    });
                } else {
                    showMessage(dataExportRes?.code || 400, this.$bvToast, this.$t(dataExportRes?.message || 'system.error'));
                    this.isProcessing = false;
                    this.downloadProgress = 0;
                }
            } catch (error) {
                showMessage(error?.code || 400, this.$bvToast, this.$t(error?.message || 'system.error'));
                this.isProcessing = false;
                this.downloadProgress = 0;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.badge {
    font-size: 0.85em;
    padding: 4px 10px;
}
</style>
